"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstances = void 0;
var wix_experiments_1 = __importDefault(require("@wix/wix-experiments"));
// accpets platform data and return instances of each class
function createInstances(_a) {
    var experiments = _a.experiments;
    return new wix_experiments_1.default({ experiments: experiments });
}
exports.createInstances = createInstances;
//# sourceMappingURL=createInstances.js.map